/**
 * WBTagalysRecommendations - client for Tagalys' v2 Recommendations API
 * (/v2/recommendations/:id). Only active when useTagalysRecos is true.
 * Transport: assets/tagalys-api.js.
 * - boughtAlsoBought: the built-in bought_also_bought recommendation (same ID on
 *   every store, Tagalys 07.10.2026) for one product (product_ids[]=).
 * - bestSellers: the v2 Smart Widgets per product line (config.widgets.bestSellers
 *   for sportswear, config.widgets.bestSellersNutrition for nutrition).
 */
(function () {
  var LABEL = '[WBTagalysRecommendations]';

  // Results are shown as Tagalys returns them (order, colours, product lines);
  // only the shop rules apply (hidden products, preview-launch holdback - see
  // WBTagalysSearchAdapter). The v2 API allows 1-32 products per widget call.
  var V2_MAX_COUNT = 32;

  function widgets() {
    return (window.wbTagalysSearchConfig && window.wbTagalysSearchConfig.widgets) || {};
  }

  // v2 recommendation; productId (the top-level Shopify product ID, not a
  // variant ID) is optional - shop-wide widgets take none. Resolves to
  // render-ready hits, [] on failure.
  function fetchV2Widget(widgetId, productId, limit, isNutrition) {
    limit = limit || 12;
    var params = {
      include: ['products'],
      count: Math.min(limit, V2_MAX_COUNT)
    };
    if (productId) params.product_ids = [String(productId)];
    return window.WBTagalysApi.get('/v2/recommendations/' + widgetId, params, { label: LABEL }).then(function (response) {
      return window.WBTagalysSearchAdapter.fromProducts(response).slice(0, limit);
    });
  }

  // Best sellers of the product line: the nutrition widget on nutrition PDPs /
  // side carts, the sportswear one otherwise (the sportswear widget stands in
  // while no nutrition widget is configured). [] when no widget is configured.
  function bestSellersWidgetType(isNutrition) {
    return isNutrition && widgets().bestSellersNutrition ? 'best_sellers_nutrition' : 'best_sellers';
  }
  function bestSellers(limit, isNutrition) {
    var id = recommendationId(bestSellersWidgetType(isNutrition));
    if (!id) return Promise.resolve([]);
    return fetchV2Widget(id, null, limit, isNutrition);
  }

  function boughtAlsoBought(productId, limit, isNutrition) {
    if (!productId) return Promise.resolve([]);
    // Customers also bought comes from Shopify (assets/shopify-recommendations.js) when it is loaded.
    if (window.WBShopifyRecommendations) return window.WBShopifyRecommendations.alsoBought(productId, limit, isNutrition);
    return fetchV2Widget(recommendationId('bought_also_bought'), productId, limit, isNutrition);
  }

  // Our widget type -> Tagalys' v2 recommendation ID, for the request and for
  // recommendations_viewed. bought_also_bought is built in on every store; best
  // sellers use the dashboard widget IDs (null when not configured).
  function recommendationId(widgetType) {
    if (widgetType === 'bought_also_bought') return 'bought_also_bought';
    if (widgetType === 'best_sellers') return widgets().bestSellers || null;
    if (widgetType === 'best_sellers_nutrition') return widgets().bestSellersNutrition || null;
    return null;
  }

  // Widget impression - every place that shows Tagalys recommendations calls
  // this (PDP tabs, PDP related products, side cart): recommendations_viewed
  // through Tagalys' SDK (snippets/tagalys-analytics.liquid).
  function trackWidgetImpression(widgetType, sourceProductId, hits) {
    // Shopify's also-bought list is not a Tagalys widget: no Tagalys impression for it.
    if (widgetType === 'bought_also_bought' && window.WBShopifyRecommendations) return;
    var id = recommendationId(widgetType);
    if (!id || !hits || !hits.length || !window.wbTagalysAnalytics) return;
    var productIds = hits.map(function (hit) { return String(hit.id); });
    window.wbTagalysAnalytics(function (analytics) {
      var payload = { id: id, recommended_product_ids: productIds };
      if (sourceProductId) payload.source_product_ids = [String(sourceProductId)];
      analytics.trackEvent('recommendations_viewed', payload);
    });
  }

  window.WBTagalysRecommendations = {
    bestSellers: bestSellers,
    bestSellersWidgetType: bestSellersWidgetType,
    boughtAlsoBought: boughtAlsoBought,
    trackWidgetImpression: trackWidgetImpression
  };
})();
